<template>
  <v-dialog :value="open" persistent max-width="700px">
    <v-card>
      <v-card-text>
        <v-container>
          <h1>{{ $t('option.deleteConfirmationTitle') }}</h1>
        </v-container>
      </v-card-text>
      <v-card-text>
        <v-container>
          {{ $t('option.deleteConfirmationMessage', {optionName: option.name}) }}
        </v-container>
      </v-card-text>
      <v-card-actions>
        <div class="ma-auto">
          <v-btn
            color="primary"
            tile
            :loading="deleting"
            @click="confirmDeleteOption"
            class="mx-1"
          >
            {{ $t('global.validate') }}
          </v-btn>
          <v-btn
            color="ternary"
            dark
            tile
            @click="cancel"
            class="mx-1"
          >
            {{ $t('global.cancel') }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import optionService from '@/services/options.js';

export default {
  name: 'DeleteOptionDialog',

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    option: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      deleting: false,
    }
  },

  methods: {
    cancel () {
      this.$emit('cancel-option-deletion');
    },

    confirmDeleteOption () {
      this.deleting = true;
      optionService.deleteOption(this.$route.params.id, this.option.id)
        .then(() => {
          this.$emit('option-deleted', { optionId: this.option.id })
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] });
        })
        .finally(() => {
          this.deleting = false;

          // this.openDeleteDialog = false;
          // this.optionToDelete = {};
        });
    },
  },
};
</script>